const INITIAL_ITEM_COUNT = 10;
const MAX_ITEM_COUNT = 20;
const INITIAL_ITEM_COUNT_MOBILE = 6;
const MAX_ITEM_COUNT_MOBILE = 12;

export const getUserRecommendationsMaxItemCount = (isMobile: boolean): number =>
    isMobile ? MAX_ITEM_COUNT_MOBILE : MAX_ITEM_COUNT;

export const useUserRecommendationsItemCounts = (
    isMobile: boolean
): {
    initialItemCount: number;
    maxItemCount: number;
    moreItemCount: number;
} => {
    const initialItemCount = isMobile ? INITIAL_ITEM_COUNT_MOBILE : INITIAL_ITEM_COUNT;
    const maxItemCount = getUserRecommendationsMaxItemCount(isMobile);

    return {
        initialItemCount,
        maxItemCount,
        moreItemCount: maxItemCount - initialItemCount,
    };
};
